import React from 'react';

import cn from 'classnames';

import { Flex } from '@shared/ui';

import cls from './AlbumsInterface.module.css';
import { useAlbumsInterface } from './useAlbumsInterface';
import { AddMediaButton } from '../AddMediaButton';
import { Albums } from '../Albums';
import { MassSelection } from '../MassSelection';

interface AlbumsInterfaceProps {
    classes?: string;
    is_customer: boolean;
    progress_tariff_access_edit: boolean;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;

    onNotOwnerHandler: () => void;
}

export const AlbumsInterface = ({
    classes,
    handleInputChange,
    is_customer,
    progress_tariff_access_edit,
    onNotOwnerHandler,
}: AlbumsInterfaceProps) => {
    const { albums } = useAlbumsInterface();

    return (
        <Flex gap={12} className={cn(cls.AlbumsInterface, [classes])}>
            <AddMediaButton
                is_customer={is_customer}
                handleInputChange={handleInputChange}
                onNotOwnerHandler={onNotOwnerHandler}
                progress_tariff_access_edit={progress_tariff_access_edit}
            />
            <MassSelection />
            {!!albums.length && <Albums />}
        </Flex>
    );
};
